(ns priorities.specs
  (:require
    [cljs.spec.alpha :as s]
    [entities.priorities.specs :as e]
    [cljs.spec.gen.alpha :as gen]
    )
  )

(s/def ::uuid (s/with-gen
                #(instance? cljs.core/UUID %)
                ;; TODO figure out how to invoke random-uuid without abusing
                ;; fmap like this ... gen/string-alphanumeric is not really used
                (fn [] (gen/fmap #(random-uuid) (gen/string-alphanumeric)))))

(s/def ::id (s/or :client-generated ::uuid
                  :server-generated ::e/id
                  :default number?))

(s/def ::goal (s/merge ::e/goal (s/keys :req-un [::id])))

(s/def ::goals (s/coll-of ::goal))
(s/def ::order (s/and integer? #(> % -1)))
(s/def ::selected? boolean?)
(s/def ::type #{:default :custom})
(s/def ::editing? boolean?)

(s/def ::stateful-priority (s/keys :req-un [::id]
                                   :opt-un [::selected?
                                            ::type
                                            ::editing?]))
(s/def ::priority (s/merge ::e/priority ::stateful-priority))
(s/def ::priorities (s/coll-of ::priority))

(s/def :form/priorities (s/map-of ::id some?))
(s/def ::selected (s/map-of ::id some?))

(s/def ::action #{:selecting :editing})
(s/def ::priority-under-edit ::id)
(s/def ::form (s/keys :opt-un [:form/priorities
                               ::selected
                               ::action
                               ::editing?
                               ::priority-under-edit]))

(s/def ::financial-priorities (s/nilable (s/keys :opt-un [::form])))
